import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { centsClient } from "../../api/cents/clients/cents-client";
import { useCallback } from "react";

export function useCentsStripePublicKey(): { get: () => Promise<string> } {
  const publicKey = useSelector((state: RootState) => state.payment.stripePublicKey);


  const get = useCallback(async () => {
    if (publicKey) {
      return publicKey
    } else {
      return await centsClient.stripe.get();
    }
  }, [publicKey]);

  return { get };
}